import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditTposItem from "./EditTposItem";
import { EditItemsProps } from "@/app/types/line-items";
import { Modal, TouchableWithoutFeedback, View, FlatList } from "react-native";
import { getIndividualItems } from "@/app/selectors/lineItem";
import { RootState } from "@/app/reducers";
import updateIcon from "@/assets/update-all.png";
import TposButton from "../../Buttons/TposButton";
import { TposIcon } from "../../Icons/TposIcon";
import { useTranslateText } from "@/app/utils/translations";
import { editItemStyles as styles } from "./styles";
import {
  editIndividualOptions,
  updateIndividualOptionsAsync,
} from "@/app/actions/options";
import { Dispatch } from "redux";
import {
  EditIndividualOptionsAction,
  UpdateIndividualOptionsAsyncAction,
} from "@/app/types/option";

const EditItems = (props: EditItemsProps): JSX.Element => {
  const { lineItemId, visible, onClose, onUpdatePress } = props;
  const { t } = useTranslateText();
  const dispatch =
    useDispatch<
      Dispatch<EditIndividualOptionsAction | UpdateIndividualOptionsAsyncAction>
    >();
  const individualLines = useSelector((state: RootState) =>
    getIndividualItems(state, props),
  );
  const lineItemIdNum = Number(lineItemId);

  const showCustomiseIndividual = individualLines.length > 1;

  const onCustomiseIndividualPress = () => {
    dispatch(editIndividualOptions(lineItemIdNum));
  };

  const onUpdateAllPress = () => {
    dispatch(updateIndividualOptionsAsync(lineItemIdNum));
    if (onUpdatePress) onUpdatePress();
  };

  useEffect(() => {
    if (showCustomiseIndividual) {
      dispatch(editIndividualOptions(lineItemIdNum));
    }
  }, [showCustomiseIndividual, dispatch, lineItemIdNum]);

  return (
    <Modal
      transparent={true}
      animationType="fade"
      visible={visible}
      onRequestClose={onClose}
      accessibilityViewIsModal={true}
    >
      <TouchableWithoutFeedback onPress={onClose}>
        <View style={styles.backdrop}>
          <TouchableWithoutFeedback>
            {showCustomiseIndividual ? (
              <>
                <FlatList
                  horizontal
                  showsHorizontalScrollIndicator={true}
                  decelerationRate="normal"
                  bounces={false}
                  keyExtractor={({ id }) => `${id}`}
                  contentContainerStyle={styles.listContentContainer}
                  style={styles.listContainer}
                  data={individualLines}
                  getItemLayout={(data, index) => ({
                    length: 450, // approximate width of each item
                    offset: 450 * index,
                    index,
                  })}
                  renderItem={({ item }) => {
                    return (
                      <EditTposItem
                        customiseIndividual={false}
                        onUpdatePress={onUpdatePress}
                        onClose={onClose}
                        lineItemId={`${item.id}`}
                      />
                    );
                  }}
                />
                <View style={styles.bottomContainer}>
                  <TposButton
                    styles={{
                      buttonText: styles.updateAllButtonText,
                      buttonContainer: styles.updateAllContainer,
                    }}
                    onPress={onUpdateAllPress}
                    buttonText={t("tpos.productArea.updateAllItems")}
                  >
                    <TposIcon icon={updateIcon} />
                  </TposButton>
                </View>
              </>
            ) : (
              <EditTposItem
                customiseIndividual
                setShowCustomiseIndividual={onCustomiseIndividualPress}
                onUpdatePress={onUpdatePress}
                onClose={onClose}
                lineItemId={lineItemId}
              />
            )}
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

export default EditItems;
